var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5F99FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66663 1.16663C8.26493 1.16663 8.74996 1.65165 8.74996 2.24996H15.25C15.25 1.65165 15.735 1.16663 16.3333 1.16663C16.9316 1.16663 17.4166 1.65165 17.4166 2.24996C20.4082 2.24996 22.8333 4.67508 22.8333 7.66663V17.4166C22.8333 20.4082 20.4082 22.8333 17.4166 22.8333H6.58329C3.59175 22.8333 1.16663 20.4082 1.16663 17.4166V7.66663C1.16663 4.67508 3.59175 2.24996 6.58329 2.24996C6.58329 1.65165 7.06832 1.16663 7.66663 1.16663ZM5.49996 9.83329C5.49996 9.23498 5.98498 8.74996 6.58329 8.74996H17.4166C18.0149 8.74996 18.5 9.23498 18.5 9.83329C18.5 10.4316 18.0149 10.9166 17.4166 10.9166H6.58329C5.98498 10.9166 5.49996 10.4316 5.49996 9.83329ZM15.25 17.4166C15.25 16.8183 15.735 16.3333 16.3333 16.3333H17.4166C18.0149 16.3333 18.5 16.8183 18.5 17.4166C18.5 18.0149 18.0149 18.5 17.4166 18.5H16.3333C15.735 18.5 15.25 18.0149 15.25 17.4166Z",
    fill: "#5F99FF",
    stroke: "black",
    strokeOpacity: 0,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.4121c5f3.svg";
export { ForwardRef as ReactComponent };